import { useInfoCard } from "./infoCard"

export const FieldInfoComponent = ({ name, fieldDetails }: FieldInfoProps) => {
  const { openInfoCard } = useInfoCard()
  const fieldDetail = fieldDetails.find((field) => field.name === name)
  if (fieldDetail == null) {
    return null
  }

  const displayName = fieldDetail.name.charAt(0).toUpperCase() + fieldDetail.name.slice(1)
  const guidance = fieldDetail.guidance

  return (
    <button
      type="button"
      onClick={() => openInfoCard({ name: displayName, guidance })}
      className="ml-2 inline-flex h-5 w-5 items-center justify-center rounded-full bg-blue-500 text-xs font-bold text-white transition-colors hover:bg-blue-600"
      title={`Click for guidance about: ${fieldDetail.name}`}
    >
      ?
    </button>
  )
}

export interface FieldDetail {
  section: string
  name: string
  guidance: string
}

export interface FieldInfoProps {
  name: string
  fieldDetails: FieldDetail[]
}
